<template>
<div class="chapter">
<div class="inner_page">
<p class="part-h"><span>PART I</span></p>
<p class="center"><span>Then the Lord asked Satan:</span></p>
<p class="center1"><span>Have you considered My servant Job?</span></p>
<p class="right-1a"><span><i>—Job 1:8</i></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part01.vue?d1a16898